import React, { useEffect, useState } from 'react';
import A from '../Anchor/Anchor';
import { FiMinus, FiPlus } from 'react-icons/fi';

import './CartQuantity.scss';

const CartQuantity = props => {
  const {
    productName,
    value,
    onIncrement,
    onDecrement,
    primaryColor,
    uiVariantButton,
    availableLessThanRequested,
    isBig = false,
    isInverse = false,
    disabled,
    style = {},
  } = props;

  const minusDisabled = value === 1 || disabled;
  const plusDisabled = value === 99 || disabled;

  const getBorderRadius = (uiVariantButton, isBig) => {
    switch (uiVariantButton) {
      case '1':
        return isBig ? '12px' : '8px';
      case '2':
        return '0';
      case '3':
        return isBig ? '6px' : '4px';
    }
  };

  return (
    <div className={`quantity ${isBig ? 'big' : ''}`} style={{ ...style }}>
      <A
        href="#"
        aria-label={
          !!productName
            ? `Rimuovi 1 pezzo di ${productName} dal carello`
            : `Rimuovi 1 pezzo dal carello`
        }
        onClick={onDecrement}
        className={`minus ${minusDisabled ? 'btn-outline' : 'btn-primary'}`}
        style={{
          backgroundColor: isInverse ? '#fff' : 'primaryColor',
          color: isInverse || minusDisabled ? primaryColor : '#fff',
          opacity: disabled ? 0.2 : 1,
          cursor: disabled ? 'not-allowed' : 'pointer',
          borderRadius: getBorderRadius(uiVariantButton, isBig),
        }}
      >
        <FiMinus />
      </A>

      <span
        className={`value ${availableLessThanRequested ? 'not-available' : ''}`}
      >
        {value}
      </span>

      <A
        href="#"
        aria-label={
          !!productName
            ? `Aggiungi 1 pezzo di ${productName} al carello`
            : `Aggiungi 1 pezzo al carello`
        }
        onClick={onIncrement}
        className={`plus ${plusDisabled ? 'btn-outline' : 'btn-primary'}`}
        style={{
          backgroundColor: isInverse ? '#fff' : 'primaryColor',
          color: isInverse || plusDisabled ? primaryColor : '#fff',
          opacity: disabled ? 0.2 : 1,
          cursor: disabled ? 'not-allowed' : 'pointer',
          borderRadius: getBorderRadius(uiVariantButton, isBig),
        }}
      >
        <FiPlus />
      </A>
    </div>
  );
};

export default CartQuantity;
